import { InjectionToken } from '@angular/core';

export const APP_VERSION: InjectionToken<string> = new InjectionToken(
  'AppVersion'
);
